<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="getDataTable" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item, index }">
          <v-tooltip v-if="$ability.can('Editar','Inadimplencia')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogFormInadimplencia.show(true, item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            Editar
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Deletar','Inadimplencia')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="deleteFaixaInadimplencia(item, index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            Deletar
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogFormInadimplencia @updated="update($event)" ref="dialogFormInadimplencia" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Inadimplencia from "@/services/inadimplencia";
export default {
  name: "TableInadimplencia",

  components: {
    DialogFormInadimplencia: () => import("./DialogFormInadimplencia.vue")
  },

  data() {
    return {
      headers: [
        { text: "Parâmetro", value: "apelido" },
        { text: "Papel", value: "papel" },
        { text: "Faixa 1", value: "faixaInadimplencia1" },
        { text: "Faixa 2", value: "faixaInadimplencia2" },
        { text: "Ações", value: "action", sortable: false, align: "center" }
      ],
      search: "",
      serviceInadimplencia: new Inadimplencia()
    };
  },

  computed: {
    ...mapGetters("inadimplencia", ["getInadimplencia"]),

    getDataTable() {
      return this.getInadimplencia || [];
    }
  },

  methods: {
    update(newInadimplencia) {
      let index = this.$refs.dataTable.items.findIndex(
        item => item.id === newInadimplencia[1]
      );
      this.$refs.dataTable.items[index].papel = newInadimplencia[0].papel;
      this.$refs.dataTable.items[index].faixaInadimplencia1 =
        newInadimplencia[0].faixaInadimplencia1;
      this.$refs.dataTable.items[index].faixaInadimplencia2 =
        newInadimplencia[0].faixaInadimplencia2;
    },

    async deleteFaixaInadimplencia(item, index) {
      try {
        await this.serviceInadimplencia.delete(item.id);
        this.$toast.success(`Faixa de inadimpência deletada com sucesso.`);
        this.$refs.dataTable.items.splice(index, 1);
      } catch (error) {
        this.$toast.error(error);
        console.error(error);
      }
    }
  }
};
</script>

<style></style>
